import React, { useState } from "react";
import { Modal, Button as RBButton } from "react-bootstrap";
import { Typography, Radio, RadioGroup, FormControlLabel, FormControl, Stack } from '@mui/material';
import CloseButton from 'react-bootstrap/CloseButton';
import { useSelector, useDispatch } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import { bindActionCreators } from "redux";
import { Actions } from "../../../Action";
import { declineQuestionExpert, getExpertOpenPageData, getKeyTag } from "../../../API/api";
import Button from "../../../NewComponent/Button/Button";
import styles from './DeclineStyles.module.css'; // optional

const modalTitleStyle = {
  color: "rgb(42, 54, 74)",
  fontSize: "20px",
  fontFamily: "Helvetica",
};

export default function DeclineModal() {
  const modalState = useSelector((state) => state.domain);
  const dispatch = useDispatch();
  const currentPath = useLocation();
  const navigate = useNavigate();
  const expertState = useSelector((state) => state.expertOpenData);
  const {
    getOpenDataCountExpert,
    isDataLoadingExpertOpen,
    getExpertOpenData,
    advanceFilterModalToggle,
    updatePageNumberExpertOpenTab,
    getKeyTag
  } = bindActionCreators(Actions, dispatch);

  const [val, setVal] = useState(null);

  const reasons = [
    { value: 10, label: "Not in my domain." },
    { value: 11, label: "This is a cross functional question." },
    { value: 12, label: "I do not have time." },
    { value: 13, label: "Already answered by another Expert." },
  ];

  const onHandleChange = (e) => setVal(e.target.value);

  const callExpertOpenApi = () => {
    getExpertOpenPageData(
      expertState.pageNo,
      expertState.sortFilterVal.origValue,
      expertState.sortFilterVal.sortOrder,
      expertState.sortChange,
      expertState.domainFilter,
      expertState.ownRecords
    ).then((res) => {
      if (!res || !res.data.success) return;

      getExpertOpenData(res.data.data);
      getOpenDataCountExpert(res.data.count);
      isDataLoadingExpertOpen(false);
      const quesTds = res.data.data.map((obj) => obj.questionUuid);
      if (quesTds.length > 0) getKeyTag(quesTds);
    });
  };

  const declineApiCall = () => {
    const payload = {
      acceptedSLA: 0,
      action: "reject",
      expertRequestUuid: expertState.expertReqId,
      reasonId: val
    };
    declineQuestionExpert(payload).then((res) => {
      if (!res || !res.data.success) return;

      advanceFilterModalToggle({ bool: false, value: '' });
      if (currentPath.pathname.includes('recommend')) {
        updatePageNumberExpertOpenTab(0);
        navigate('/expertHome/open');
      }
      callExpertOpenApi();
    }).catch(console.log);
  };

  return (
    <Modal
      show={modalState.modalState}
      onHide={() => advanceFilterModalToggle({ bool: false, value: "" })}
      centered
      size="lg"
    >
      <Modal.Header closeButton>
        <Modal.Title style={modalTitleStyle}>
          <i className="fa fa-files-o"></i> &nbsp;&nbsp;Not able to answer?
        </Modal.Title>
      </Modal.Header>

      <Modal.Body>
        <FormControl>
          <RadioGroup
            name="decline-reasons"
            onChange={onHandleChange}
          >
            {reasons.map((d, i) => (
              <FormControlLabel
                key={i}
                value={d.value}
                control={<Radio />}
                label={
                  <Typography sx={{ fontFamily: "inherit", fontSize: "14px" }}>
                    {d.label}
                  </Typography>
                }
              />
            ))}
          </RadioGroup>
        </FormControl>

        <Stack spacing={2} direction="row" justifyContent="end" className="mt-3">
          {val === null ? (
            <span style={{ opacity: '0.5', pointerEvents: 'none' }}>
              <Button text="Send" onClickFunc={declineApiCall} type="primary" />
            </span>
          ) : (
            <Button text="Send" onClickFunc={declineApiCall} type="primary" />
          )}
        </Stack>
      </Modal.Body>
    </Modal>
  );
}
